import { InjectionToken } from '@angular/core';

export enum ParsingStrategy {
    Remote,
    Local
}

export const DATAFLOW_PARSING_STRATEGY = new InjectionToken<ParsingStrategy>('dataFlowParsingStrategy');
